import pages from './pages.js';

function v5(backendAxiosInstance) {
  return {
    ...pages(backendAxiosInstance)
  };
}

export { v5 as default };
//# sourceMappingURL=index.js.map
